if (!customElements.get('t4-tabs')) {
  customElements.define(
    't4-tabs',
    class T4Tabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.viewAll = this.querySelector('[data-tabs-view-all]');

        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', this.onClick);
          tab.addEventListener('keydown', this.onKeydown);
        });
        if (window.Shopify?.designMode) document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        this.tabs?.forEach((tab) => {
          tab.removeEventListener('click', this.onClick);
          tab.removeEventListener('keydown', this.onKeydown);
        });
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      onBlockSelect(event) {
        const panel = this.panels.find((element) => element === event.target);
        const tab = panel && this.tabs.find((element) => element.getAttribute('aria-controls') === panel.id);
        if (tab) this.select(tab);
      }

      onClick(event) {
        this.select(event.currentTarget);
      }

      onKeydown(event) {
        const index = this.tabs.indexOf(event.currentTarget);
        const keys = { ArrowRight: index + 1, ArrowLeft: index - 1, Home: 0, End: this.tabs.length - 1 };
        if (!(event.key in keys)) return;

        event.preventDefault();
        const next = this.tabs[(keys[event.key] + this.tabs.length) % this.tabs.length];
        this.select(next);
        next.focus();
      }

      select(activeTab) {
        this.tabs.forEach((tab) => {
          const isActive = tab === activeTab;
          tab.setAttribute('aria-selected', isActive);
          tab.tabIndex = isActive ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          panel.hidden = panel.id !== activeTab.getAttribute('aria-controls');
        });

        if (this.viewAll && activeTab.dataset.url) this.viewAll.href = activeTab.dataset.url;

        activeTab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }
  );
}
